import React from 'react';
import { Container, Header, Divider } from 'semantic-ui-react';

class Exit extends React.Component{
  render(){
    return <Container text textAlign='left'>
      <Header as='h3' textAlign='center'>
    Value-Added Strategy
    </Header>
    <Divider/>
      <p>
      OVC is the connector between qualified investors and nascent university-related startups. It strives
      to maximize commercial opportunities for the portfolio companies in the US and Asia drawing on
      government enterprise support schemes. Many of these government-funded enterprises are early
      adopters of science innovations. When the technologies are proven, private enterprises will acquire
      these innovations through product creation.
      </p>
      <p>
      By working with local enterprises and scientific communities, OVC gathers market intelligence from
      vertically integrated and horizontally diversified science enterprises. There is a hierarchy of industry
      specialization among ASEAN countries. By advising startups to manage their product
      commercialization, OVC creates value for itself and for the startups. Successful startups will be able
      to expedite product introduction and to maximize their sales efforts. Accordingly, OVC will benefit
      from the success of the startups.
      </p>
    </Container>;
  }
}

export default Exit;
